import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { variableLabel } from './variables';

/** "Insert customer info" menu: friendly names in the list, raw @TOKEN@ emitted. */
@Component({
  selector: 'app-insert-variable',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatMenuModule],
  template: `
    <button mat-stroked-button type="button" class="iv-btn" [matMenuTriggerFor]="menu" [matMenuTriggerRestoreFocus]="false" [disabled]="!tokens.length">
      <mat-icon>add</mat-icon>Insert customer info
    </button>
    <mat-menu #menu="matMenu">
      @for (t of tokens; track t) {
        <button mat-menu-item type="button" (click)="pick.emit(t)">
          <span>{{ label(t) }}</span><small class="iv-code">{{ t }}</small>
        </button>
      }
    </mat-menu>`,
  styles: [`
    .iv-btn { --mdc-outlined-button-label-text-color: #1565C0; background: #E3F0FD; border-color: transparent !important; }
    .iv-code { margin-left: 12px; color: #94A3B8; font-family: monospace; font-size: 11px; }
  `],
})
export class InsertVariableComponent {
  @Input() tokens: string[] = [];
  @Output() pick = new EventEmitter<string>();
  label = variableLabel;
}
